<template>
  <transition name="qr-shortcut-dialog-fade">
    <div v-if="visible" class="qr-shortcut-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭收款码弹窗" @click="handleClose">
          <img src="../../../assets/home-confirm/dialogs/qr-close.svg" alt="" class="close-icon" />
        </button>

        <div class="content">
          <p class="title">收款码信息</p>

          <div class="qr-box">
            <el-image :src="qrImageSrc" :preview-src-list="[qrImageSrc]" class="qr-image" fit="fill" />
          </div>

          <div class="pay-row">
            <span class="pay-text">请使用</span>
            <span class="pay-method">
              <img src="../../../assets/home-confirm/dialogs/qr-alipay.svg" alt="支付宝" class="pay-icon" />
              <span>支付宝</span>
            </span>
            <span class="pay-text">或</span>
            <span class="pay-method">
              <img src="../../../assets/home-confirm/dialogs/qr-wechat.svg" alt="微信" class="pay-icon" />
              <span>微信</span>
            </span>
            <span class="pay-text">扫码进行支付</span>
          </div>

          <button type="button" class="link" @click="$emit('view-fee')">
            点击查看平台收费标准
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "QrShortcutDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    qrImage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
    };
  },
  computed: {
    qrImageSrc() {
      return this.qrImage || '';
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.qr-shortcut-dialog {
  position: fixed;
  inset: 0;
  z-index: 1994;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: 380px;
  height: 421px !important;
  padding: 15px 20px 35px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.24);
}

.content {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 35px;
}

.close {
  position: absolute;
  top: 15px;
  right: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.close-icon {
  width: 14px;
  height: 14px;
}

.title {
  margin: 0;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.qr-box {
  display: flex;
  align-items: center;
  margin-top: 20px;
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 8px 7px 9px 9px;
}

.qr-image {
  width: 126px;
  height: 180px;
}

.pay-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 4px;
  margin-top: 36px;
  white-space: nowrap;
}

.pay-text,
.pay-method {
  color: #000000;
  font-size: 16px;
  line-height: 22px;
}

.pay-text {
  flex: 0 0 auto;
}

.pay-method {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
}

.pay-icon {
  width: 17px;
  height: 17px;
}

.link {
  display: block;
  margin-top: 29px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #d92f24;
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;
}

.qr-shortcut-dialog-fade-enter-active,
.qr-shortcut-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.qr-shortcut-dialog-fade-enter-active .panel,
.qr-shortcut-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.qr-shortcut-dialog-fade-enter,
.qr-shortcut-dialog-fade-leave-to {
  opacity: 0;
}

.qr-shortcut-dialog-fade-enter .panel,
.qr-shortcut-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
